<template>
  <v-form ref="form" v-model="validForm">

    <div v-if="required">
      <v-autocomplete v-model="generacionId" @change="change" :items="generaciones" item-text="descripcion"
      item-value="id" dense filled label="Generacion" clearable :return-object="returnObject"
      :rules="[rules.required]"></v-autocomplete>
    </div>
    <div v-else>
      <v-autocomplete v-model="generacionId" @change="change" :items="generaciones" item-text="descripcion"
      item-value="id" dense filled label="Generacion" clearable :return-object="returnObject"
      ></v-autocomplete>
    </div>
  </v-form>
</template>
<script>
import axios from "axios";

export default {
  props: {
    filtroId: { type: Array, default: null },
    filtroEstado: { type: Array, default: null },
    id: { type: Number, default: null },
    returnObject: { type: Boolean, default: false },
    required: { type: Boolean, default: true },
  },
  data() {
    return {
      generaciones: [],
      generacionId: null,
      validForm: false,
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 1000) || "Maximo 100 caracteres",
        counter10: (value) =>
          (value && value.length <= 10) || "Maximo 10 caracteres",
      },
    };
  },
  mounted() {

    console.log('generacionAutocomplete mounted');
    this.asignacionId = this.id;
    axios
      .get("/generaciones")
      .then((response) => {
        console.log(response);
        if (this.filtroId) {
          this.generaciones = response.data.filter((gen) =>
            this.filtroId.includes(gen.id)
          );
        } else if (this.filtroEstado) {
          this.generaciones = response.data.filter((gen) =>
            this.filtroEstado.includes(gen.estado)
          );
        } else {
          this.generaciones = response.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    change() {
      this.$emit('generacionId', this.generacionId)
    }
  }
};
</script>